import { rem } from 'polished'
import styled from 'styled-components'

import check from '../check.svg'

export const ListItem = styled.li`
  padding-left: 40px;

  &&:not(:last-child) {
    margin-bottom: ${rem(14)};
  }

  &&::before {
    content: '';
    width: 24px;
    height: 24px;
    background-image: url(${check});
    position: absolute;
    left: 0;
  }
`
